import { useCallback, useMemo } from "react";

import { useApi } from "shared/services/api/useApi";

export const useLocations = () => {
    const { getDataAsync } = useApi();

    const getLocationsFilter = useCallback(async (params) => {

        const payload = await getDataAsync("locationsFilter", { params: params });
        return payload.json();
        
    }, [getDataAsync]
    );

    return useMemo(() => {
        return { getLocationsFilter };
    }, [getLocationsFilter]);
};
